import angular from 'angular';
import { loanCalculatorComponent } from './loan-calculator-2.component';
import LoanService from './../loan.module';
import dottedNumberInput from '../../../common/directives/dottedNumberInput/dotted-number-input.moule';
const MODULE_NAME = 'loanCalculatorComponent2';

export default angular.module(MODULE_NAME, [LoanService, dottedNumberInput]).component('loanCalculatorComponent2', loanCalculatorComponent).name;
